"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitFor = void 0;
const value_1 = require("./value");
function waitFor(values) {
    const valuesArray = Array.isArray(values) ? values : [values];
    const loadingArray = [];
    const dataArray = [];
    for (const value of valuesArray) {
        if (value_1.isLoadingValue(value)) {
            loadingArray.push(value.loading);
        }
        if (value_1.isErrorValue(value)) {
            throw value.error;
        }
        dataArray.push(value.data);
    }
    if (loadingArray.length) {
        throw Promise.all(loadingArray);
    }
    return Array.isArray(values) ? dataArray : dataArray[0];
}
exports.waitFor = waitFor;
